/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputNotification
 */
export interface OutputNotification {
    /**
     * 
     * @type {string}
     * @memberof OutputNotification
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputNotification
     */
    expiresAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputNotification
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputNotification
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputNotification
     */
    read?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputNotification
     */
    title?: string;
}

/**
 * Check if a given object implements the OutputNotification interface.
 */
export function instanceOfOutputNotification(value: object): boolean {
    return true;
}

export function OutputNotificationFromJSON(json: any): OutputNotification {
    return OutputNotificationFromJSONTyped(json, false);
}

export function OutputNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'expiresAt': json['expires_at'] == null ? undefined : json['expires_at'],
        'id': json['id'] == null ? undefined : json['id'],
        'message': json['message'] == null ? undefined : json['message'],
        'read': json['read'] == null ? undefined : json['read'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function OutputNotificationToJSON(value?: OutputNotification | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'created_at': value['createdAt'],
        'expires_at': value['expiresAt'],
        'id': value['id'],
        'message': value['message'],
        'read': value['read'],
        'title': value['title'],
    };
}

